/////////////////////////////////////////////////////////////
import { ComboCard } from '@/core/interfaces';

interface DailyComboCardProps {
	card: ComboCard;
}

export const DailyComboCard: React.FC<DailyComboCardProps> = ({
	card,
}: DailyComboCardProps) => {
	/*********************
	// #region States
	**********************/

	/*********************
	// #region Template
	**********************/
	return (
		<div className="bg-vottun-950/50 rounded-lg p-1">
			<img
				className="w-[55px] h-[55px] rounded-lg"
				src={card.image}
				alt={card.title}
			/>
		</div>
	);
};
